import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { FuseSharedModule } from '@fuse/shared.module';

import { EscenarioComponent } from './escenario.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { DialogBoxComponent } from './dialog/dialog-box.component';
import {MatChipsModule} from '@angular/material/chips';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatTabsModule} from '@angular/material/tabs';
import {MatCardModule} from '@angular/material/card';
//import { MatSort } from '@angular/material/sort';
//import {MatTableDataSource} from '@angular/material/table';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { TranslateModule } from '@ngx-translate/core';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { DialogBoxPrintComponentEscenario } from './dialog/dialog-print-box.component';
import {MatIconModule} from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';



@NgModule({
    declarations: [
        EscenarioComponent,
        DialogBoxComponent,
        DialogBoxPrintComponentEscenario
    ],
    imports     : [
        BrowserAnimationsModule,
        FormsModule,
        MatTableModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatInputModule,
        MatSelectModule,
        MatChipsModule,
        FuseSharedModule,
        MatDatepickerModule,
        MatTabsModule,
        MatCardModule,
        TranslateModule,
        MatSnackBarModule,
        MatIconModule,
        //MatSort,
        //MatTableDataSource,
        NgxChartsModule,
        MatPaginatorModule
    ],
    entryComponents: [
        DialogBoxComponent,
        DialogBoxPrintComponentEscenario
    ]
})
export class EscenarioModule
{
}
